import type { ApolloError } from '@apollo/client';

/**
 * Returns true if the ApolloError contains a GraphQL error with
 * extensions.code === 'FORBIDDEN'. Used per-panel to render a
 * locked placeholder instead of data.
 */
export function isForbidden(error: ApolloError | undefined): boolean {
  if (!error?.graphQLErrors) return false;
  return error.graphQLErrors.some(
    (e) => (e.extensions as Record<string, unknown>)?.code === 'FORBIDDEN'
  );
}
